<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div ng-repeat="w in windows track by $id(w)" class="modalWrapper questVictory" style="z-index: 1165; opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div ng-controller="questVictoryCtrl" id="questVictoryWindow" clickable="close()" @click="onModalClose(close)" ng-class="{fadeIn: fadeIn, fadeOut: fadeOut}" class="clickable fadeIn">
				<div class="victoryGlow victory_glow_illustration"></div>
				<div class="victoryIllustation victory_quest302_illustration"></div>
				<div class="descriptionWrapper victory_banderole_illustration">
					<div translate="" options="35"><span>???</span></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>